import { Button, Modal, Form, message } from "antd";
import { useEffect, useState } from "react";
import formatSize from "../../../utils/formatSize";
import deleteDataGate from "../../../services/deleteDataGate";

export default function DeleteAttachment({
  isVisible,
  setVisible,
  gatepassId,
  selected,
  refetch,
}: any) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  const onSubmit = async () => {
    const uri = `api/gatepass/${gatepassId}/document/${selected?._id}`;

    const response = await deleteDataGate({ data: {}, uri, token: "" });

    if (response?.success) {
      await refetch();
      message.success("Deleted Successfully");
    } else {
      message.error("Something went wrong");
    }

    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected, form]);

  return (
    <Modal
      open={isVisible}
      title="Delete Attachment"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="deleteAttachment"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form
        id="deleteAttachment"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-toyota font-bold mx-1">Delete</span>
            Attachment For
          </div>
          <div className="font-bold text-lg">{selected?.description}?</div>

          <div className="flex flex-col justify-center">
            <div className="mr-2"></div>
            <div className="flex flex-col justify-center">
              <div className="text-xs">
                {formatSize(selected?.document?.filesize)}
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
